// // src/components/Footer.js
// import React from 'react';
// import { Box, Typography, Link } from '@mui/material';

// const Footer = () => {
//     return (
//         <footer style={{
//             width: '100%',
//             backgroundColor: '#f1f1f1',
//             textAlign: 'center',
//             padding: '10px 0',
//         }}>
//             <Box>
//                 <Typography variant="body2" color="textSecondary">
//                     Powered by{' '}
//                     <Link
//                         href="https://www.chaosology.com/"
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         underline="hover"
//                         sx={{ color: "#1E2548", fontWeight: "bold" }}
//                     >
//                         Chaosology
//                     </Link>
//                 </Typography>
//             </Box>
//         </footer>
//     );
// };

// export default Footer;
// src/components/Footer.js
// src/components/Footer.js
// src/components/Footer.js
// src/components/Footer.js
import React from "react";
import {
  Box,
  Typography,
  Link,
  IconButton,
  Grid,
} from "@mui/material";
import { useLocation } from "react-router-dom";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import YouTubeIcon from "@mui/icons-material/YouTube";

/* ===== BRAND COLORS ===== */
const FOOTER_BG = `
  linear-gradient(
    180deg,
    #3A3A3A 0%,
    #2F2A26 100%
  )
`;

const BRAND_GOLD = "#F3C26B";
const MUTED_GOLD = "#F3C26B";
const TEXT_LIGHT = "#E6E6E6";

// const Footer = () => {

//      const location = useLocation();

//   // Pages that need FULL footer
//   const smallFooterPages = ["/", "/ii-cost-savings"];
//   const isSmallFooter = smallFooterPages.includes(location.pathname);

//   // ================= SMALL FIXED FOOTER =================
//   if (isSmallFooter) {
//     return (
//       <Box
//         component="footer"
//         sx={{
//           position: "fixed",
//           bottom: 0,
//           left: 0,
//           width: "100%",
//           height: 48,
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           background: `
//             linear-gradient(
//               180deg,
//               #3A3A3A 0%,
//               #2F2A26 100%
//             )
//           `,
//           borderTop: "1px solid rgba(255,255,255,0.15)",
//           zIndex: 1300,
//         }}
//       >
//         <Typography fontSize={13} sx={{ color: "#e0e0e0" }}>
//           © {new Date().getFullYear()} Savy & Sons. All Rights Reserved &nbsp;|&nbsp;
//           Powered by{" "}
//           <Link
//             href="https://www.chaosology.com/"
//             target="_blank"
//             rel="noopener noreferrer"
//             underline="hover"
//             sx={{ color: "#F3C26B", fontWeight: "bold" }}
//           >
//             Chaosology
//           </Link>
//         </Typography>
//       </Box>
//     );
//   }
//   return (
//     <Box
//       component="footer"
//       sx={{
//         background: FOOTER_BG,   // ✅ FIXED
//         color: TEXT_LIGHT,
//         mt: 0,
//         pt: 6,
//       }}
//     >
//       {/* ================= MAIN CONTENT ================= */}
//       <Grid
//         container
//         spacing={4}
//         justifyContent="center"
//         textAlign="center"
//         sx={{
//           maxWidth: 1200,
//           mx: "auto",
//           px: { xs: 2, sm: 4 },
//         }}
//       >
//         {/* ===== ABOUT ===== */}
//         <Grid item xs={12} md={4}>
//           <Typography
//             variant="h6"
//             fontWeight="bold"
//             sx={{ color: BRAND_GOLD }}
//             mb={1}
//           >
//             Savy & Sons
//           </Typography>

//           <Typography
//             fontSize={14}
//             sx={{ color: TEXT_LIGHT, lineHeight: 1.7 }}
//             maxWidth={360}
//             mx="auto"
//           >
//             We provide media blasting, waterproofing solutions,
//             no-dig pipe repairs, and infrastructure restoration solutions.
//           </Typography>
//         </Grid>

//         {/* ===== SERVICES ===== */}
//         <Grid item xs={12} md={4}>
//           <Typography
//             variant="h6"
//             fontWeight="bold"
//             sx={{ color: BRAND_GOLD }}
//             mb={1}
//           >
//             Services
//           </Typography>

//           <Typography
//             fontSize={14}
//             sx={{ color: TEXT_LIGHT, lineHeight: 1.9 }}
//             maxWidth={420}
//             mx="auto"
//           >
//             • Waterproofing Solutions &nbsp; • Water & Wastewater Rehabilitation
//             <br />
//             • Coatings & Linings &nbsp; • Infrastructure Restoration
//             <br />
//             • Pipe Lining Services &nbsp; • Media Blasting
//             <br />
//             • Seawall Repair &nbsp; • Concrete Leveling &nbsp; • Slip Lining
//           </Typography>
//         </Grid>

//         {/* ===== CONTACT ===== */}
//         <Grid item xs={12} md={4}>
//           <Typography
//             variant="h6"
//             fontWeight="bold"
//             sx={{ color: BRAND_GOLD }}
//             mb={1}
//           >
//             Contact Us
//           </Typography>

//           <Typography fontSize={14} fontWeight="bold" sx={{ color: MUTED_GOLD }}>
//             Visit Us
//           </Typography>
//           <Typography fontSize={14} sx={{ color: TEXT_LIGHT }} mb={1}>
//             612 Church St., Amston, CT, 06231
//           </Typography>

//           <Typography fontSize={14} fontWeight="bold" sx={{ color: MUTED_GOLD }}>
//             Email Us
//           </Typography>
//           <Link
//             href="mailto:office@savyandsons.com"
//             underline="hover"
//             sx={{
//               color: BRAND_GOLD,
//               fontWeight: 600,
//               display: "block",
//               mb: 1,
//             }}
//           >
//             office@savyandsons.com
//           </Link>

//           <Typography fontSize={14} fontWeight="bold" sx={{ color: MUTED_GOLD }}>
//             Call Us
//           </Typography>
//           <Link
//             href="tel:+18605908095"
//             underline="hover"
//             sx={{ color: BRAND_GOLD, fontWeight: 600 }}
//           >
//             (860) 590-8095
//           </Link>
//         </Grid>
//       </Grid>

//       {/* ================= SOCIAL MEDIA ================= */}
//       <Box sx={{ textAlign: "center", mt: 6 }}>
//         <Typography
//           variant="h6"
//           fontWeight="bold"
//           mb={2}
//           sx={{ color: BRAND_GOLD }}
//         >
//           FOLLOW US ON SOCIAL MEDIA
//         </Typography>

//         <Box>
//           {[
//             {
//               icon: <FacebookIcon />,
//               url: "https://www.facebook.com/savysons/",
//             },
//             {
//               icon: <InstagramIcon />,
//               url: "https://www.instagram.com/savyandsons/",
//             },
//             {
//               icon: <LinkedInIcon />,
//               url: "https://www.linkedin.com/company/savy-sons",
//             },
//             {
//               icon: <YouTubeIcon />,
//               url: "https://www.youtube.com/channel/UCZakr24nabLG2GoCS38CfwA",
//             },
//           ].map((item, i) => (
//             <IconButton
//               key={i}
//               component="a"
//               href={item.url}
//               target="_blank"
//               rel="noopener noreferrer"
//               sx={{
//                 mx: 1,
//                 color: "#fff",
//                 background: "rgba(255,255,255,0.08)",
//                 "&:hover": {
//                   background: BRAND_GOLD,
//                   color: "#000",
//                 },
//               }}
//             >
//               {item.icon}
//             </IconButton>
//           ))}
//         </Box>
//       </Box>

//       {/* ================= BOTTOM BAR ================= */}
//       <Box
//         sx={{
//           borderTop: "1px solid rgba(255,255,255,0.15)",
//           mt: 5,
//           py: 2,
//           textAlign: "center",
//         }}
//       >
//         <Typography fontSize={13} sx={{ color: "#cfcfcf" }}>
//           © {new Date().getFullYear()} Savy & Sons. All Rights Reserved
//         </Typography>

//         <Typography fontSize={12} mt={0.5}>
//           Powered by{" "}
//           <Link
//             href="https://www.chaosology.com/"
//             target="_blank"
//             rel="noopener noreferrer"
//             underline="hover"
//             sx={{ color: BRAND_GOLD, fontWeight: "bold" }}
//           >
//             Chaosology
//           </Link>
//         </Typography>
//       </Box>
//     </Box>
//   );
// };

const Footer = () => {
  const location = useLocation();

  // Pages that need SMALL fixed footer
  const smallFooterPages = ["/", "/ii-cost-savings"];
  const isSmallFooter = smallFooterPages.includes(location.pathname);

  /* ================= SMALL FIXED FOOTER ================= */
  if (isSmallFooter) {
      return (
    <Box
      component="footer"
      sx={{
        background: FOOTER_BG,   // ✅ FIXED
        color: TEXT_LIGHT,
        mt: 0,
        pt: 6,
      }}
    >
      {/* ================= MAIN CONTENT ================= */}
      <Grid
        container
        spacing={4}
        justifyContent="center"
        textAlign="center"
        sx={{
          maxWidth: 1200,
          mx: "auto",
          px: { xs: 2, sm: 4 },
        }}
      >
        {/* ===== ABOUT ===== */}
        <Grid item xs={12} md={4}>
          <Typography
            variant="h6"
            fontWeight="bold"
            sx={{ color: BRAND_GOLD }}
            mb={1}
          >
            Savy & Sons
          </Typography>

          <Typography
            fontSize={14}
            sx={{ color: TEXT_LIGHT, lineHeight: 1.7 }}
            maxWidth={360}
            mx="auto"
          >
            We provide media blasting, waterproofing solutions,
            no-dig pipe repairs, and infrastructure restoration solutions.
          </Typography>
        </Grid>

        {/* ===== SERVICES ===== */}
        <Grid item xs={12} md={4}>
          <Typography
            variant="h6"
            fontWeight="bold"
            sx={{ color: BRAND_GOLD }}
            mb={1}
          >
            Services
          </Typography>

          <Typography
            fontSize={14}
            sx={{ color: TEXT_LIGHT, lineHeight: 1.9 }}
            maxWidth={420}
            mx="auto"
          >
             Waterproofing Solutions &nbsp;  Water & Wastewater Rehabilitation
            <br />
            Coatings & Linings &nbsp; Infrastructure Restoration
            <br />
            Pipe Lining Services &nbsp;  Media Blasting  <br />
           Seawall Repair &nbsp;  Low Density Cellular Concrete  &nbsp; 
            <br />
            Concrete Leveling &nbsp;  Slip Lining
          </Typography>
        </Grid>

        {/* ===== CONTACT ===== */}
        <Grid item xs={12} md={4}>
          <Typography
            variant="h6"
            fontWeight="bold"
            sx={{ color: BRAND_GOLD }}
            mb={1}
          >
            Contact Us
          </Typography>

          <Typography fontSize={14} fontWeight="bold" sx={{ color: MUTED_GOLD }}>
            Visit Us
          </Typography>
          <Typography fontSize={14} sx={{ color: TEXT_LIGHT }} mb={1}>
            612 Church St., Amston, CT, 06231
          </Typography>

          <Typography fontSize={14} fontWeight="bold" sx={{ color: MUTED_GOLD }}>
            Email Us
          </Typography>
          <Link
            href="mailto:frontdesk@savyandsons.com"
            sx={{
              color: BRAND_GOLD,
              fontWeight: 600,
              display: "block",
              textDecoration:"none",
              mb: 1,
            }}
          >
            frontdesk@savyandsons.com
          </Link>
 
          <Typography fontSize={14} fontWeight="bold" sx={{ color: MUTED_GOLD }}>
            Call Us
          </Typography>
          <Link
            href="tel:+18607301518"
            // underline="hover"
            sx={{ color: BRAND_GOLD, fontWeight: 600, textDecoration:"none" }}
          >
          (860) 730-1518
          </Link>
        </Grid>
      </Grid>

      {/* ================= SOCIAL MEDIA ================= */}
      <Box sx={{ textAlign: "center", mt: 6 }}>
        <Typography
          variant="h6"
          fontWeight="bold"
          mb={2}
          sx={{ color: BRAND_GOLD }}
        >
          FOLLOW US ON SOCIAL MEDIA
        </Typography>

        <Box>
          {[
            {
              icon: <FacebookIcon />,
              url: "https://www.facebook.com/savysons/",
            },
            {
              icon: <InstagramIcon />,
              url: "https://www.instagram.com/savyandsons/",
            },
            {
              icon: <LinkedInIcon />,
              url: "https://www.linkedin.com/company/savy-sons",
            },
            {
              icon: <YouTubeIcon />,
              url: "https://www.youtube.com/channel/UCZakr24nabLG2GoCS38CfwA",
            },
          ].map((item, i) => (
            <IconButton
              key={i}
              component="a"
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                mx: 1,
                color: "#fff",
                background: "rgba(255,255,255,0.08)",
                "&:hover": {
                  background: BRAND_GOLD,
                  color: "#000",
                },
              }}
            >
              {item.icon}
            </IconButton>
          ))}
        </Box>
      </Box>

      {/* ================= BOTTOM BAR ================= */}
      <Box
        sx={{
          borderTop: "1px solid rgba(255,255,255,0.15)",
          mt: 5,
          py: 2,
          textAlign: "center",
        }}
      >
        <Typography fontSize={13} sx={{ color: "#cfcfcf" }}>
          © {new Date().getFullYear()} Savy & Sons. All Rights Reserved
        </Typography>

        <Typography fontSize={12} mt={0.5}>
          Powered by{" "}
          <Link
            href="https://www.chaosology.com/"
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            sx={{ color: BRAND_GOLD, fontWeight: "bold" }}
          >
            Chaosology
          </Link>
        </Typography>
      </Box>
    </Box>
  );
   
  }

  /* ================= SIMPLE FOOTER (ALL OTHER PAGES) ================= */
 return (
      <Box
        component="footer"
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          width: "100%",
          height: 48,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
         background: "linear-gradient(180deg, #FFF4D6 0%, #FBE8B0 100%)",
borderTop: "1px solid #F3C26B",

          zIndex: 1300,
        }}
      >
        <Typography fontSize={13} sx={{  color: "#1F1F1F",
          fontWeight: 500, }}>
          © {new Date().getFullYear()} Savy & Sons. All Rights Reserved &nbsp;|&nbsp;
          Powered by{" "}
          <Link
            href="https://www.chaosology.com/"
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            sx={{ color: "#F3C26B", fontWeight: "bold" }}
          >
            Chaosology
          </Link>
        </Typography>
      </Box>
    );
};

export default Footer;



